export enum StyleConstants {
  // NAV_BAR_HEIGHT = '4rem',
  NAV_BAR_HEIGHT = '0',
}
